export interface ICoriolisExport {
    automatic_export:boolean
    last_export:string,
    file_list:Array<string>
}

export const getDefaultCoriolisExport = ():ICoriolisExport => {
    return {
        automatic_export:true,
        last_export:'',
        file_list:[]
    }
}